import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import PlotTimeline from "./components/PlotTimeline";
import Characters from "./components/Characters";
import Chapters from "./components/Chapters";
import Clues from "./components/Clues";
import Faq from "./components/Faq";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="w-full bg-background-50">
      <Navbar />
      <Hero />
      <PlotTimeline />
      <Characters />
      <Chapters />
      <Clues />
      <Faq />
      <About />
      <Contact />
      <Footer />
    </main>
  );
}